import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import initApp from 'utils/functions/init';
import { contexts } from 'constants/context';
import { fetchAdvertsList } from 'modules/adverts/actions';
import AdvertsView from 'modules/adverts/views/AdvertsView';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AdvertsPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const campaignKey = searchParams.get('campaignKey');

  const advertsListApiCallBody = useMemo(() => {
    const data = {
      page: 1,
      pageSize: 10,
    };
    if (campaignKey) data.campaignKey = campaignKey;

    return data;
  }, [campaignKey]);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const body = {
      data: advertsListApiCallBody,
    };
    dispatch(fetchAdvertsList(body));

    initApp(contexts.adverts);
  }, [advertsListApiCallBody, dispatch]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <AdvertsView advertsListApiCallBody={advertsListApiCallBody} />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

AdvertsPage.propTypes = {};

AdvertsPage.defaultProps = {};

export default AdvertsPage;
